export default {
  index: {
    title: 'Marcação Médica de Macau',
    banner: {
      smartMedical: 'Saúde Inteligente',
      convenientService: 'Marcação Conveniente, Serviço de Qualidade',
      specializedMedical: 'Tratamento Especializado',
      crossBorder: 'MTC e Serviços Transfronteiriços'
    },
    quickEntry: {
      appointment: 'Marcação',
      vaccine: 'Vacinação',
      records: 'Registros',
      department: 'Departamentos'
    },
    news: {
      title: 'Notícias Hospitalares',
      vaccine: 'Novo Ponto de Vacinação em Macau',
      cooperation: 'Novo Progresso na Cooperação Médica da Grande Baía'
    },
    featured: {
      title: 'Serviços Médicos Especiais da Grande Baía',
      tcm: 'Medicina Tradicional Chinesa',
      tcmDesc: 'Tradicional e Moderna',
      crossBorder: 'Serviços Transfronteiriços',
      crossBorderDesc: 'Passagem Conveniente',
      expert: 'Clínica Especializada',
      expertDesc: 'Médicos Especialistas'
    }
  },
  tabbar: {
    home: 'Início',
    appointment: 'Marcação',
    my: 'Meu'
  },
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    loading: 'Carregando...',
    more: 'Mais',
    viewAll: 'Ver Tudo',
    viewMore: 'Ver Mais',
    search: {
      placeholder: 'Pesquisar departamentos/médicos/doenças',
      history: 'Histórico de pesquisa',
      hot: 'Pesquisas populares',
      clear: 'Limpar',
      cancel: 'Cancelar'
    },
    language: {
      select: 'Selecionar Idioma'
    },
    tag: {
      new: 'Novo'
    },
    status: {
      available: 'Disponível',
      busy: 'Ocupado',
      full: 'Lotado'
    },
    unit: {
      person: 'pessoas',
      km: 'km',
      score: 'pontos'
    }
  },
  department: {
    search: {
      tabs: {
        department: 'Departamento',
        doctor: 'Médico',
        disease: 'Doença'
      },
      result: {
        doctorCount: '{count} médicos',
        rating: 'Avaliação',
        distance: 'Distância',
        book: 'Agendar'
      }
    },
    category: {
      all: 'Todos',
      covid: 'Vacina Coronavírus',
      flu: 'Vacina Gripe',
      hpv: 'Vacina HPV',
      child: 'Vacinas Infantis'
    }
  }
} 